import React, { CSSProperties } from 'react';
import clsx from 'clsx';
import { useSelectProject } from '../../utils/dataStateHooks';
import { PageInfoItemDevice, PageInfoItemHome, PageInfoItemUser, usePageInfoStyles } from './PageInfoUtils';
import { useGetURLParamEntityIdAsNumber } from '../../utils/utils';



export interface PageInfoBarContainerProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
}


export const PageInfoBarContainer: React.FC<PageInfoBarContainerProps> = (props: PageInfoBarContainerProps) => {

    const projectId = useGetURLParamEntityIdAsNumber('projectId');
    const userId = useGetURLParamEntityIdAsNumber('userId');
    const homeId = useGetURLParamEntityIdAsNumber('homeId');
    const deviceId = useGetURLParamEntityIdAsNumber('deviceId');

    const project = useSelectProject(projectId);
    const classes = usePageInfoStyles();

    if (project) {
        return (
            <div className={clsx(classes.root, props.className)} style={props.style}>
                <PageInfoItemUser projectId={project.id} userId={userId} homeId={homeId} deviceId={deviceId} />
                <PageInfoItemHome projectId={project.id} userId={userId} homeId={homeId} deviceId={deviceId} />
                <PageInfoItemDevice projectId={project.id} userId={userId} homeId={homeId} deviceId={deviceId} />
            </div>
        );
    }

    return (
        <></>
    );
};
